type checkForSessionCart = {
    ociSessionId?: string;
};

type UseIdsSessionType = {
    checkForSessionCart: () => checkForSessionCart;
};

const LOCAL_STORAGE_KEY = 'ociSessionId';

export const useSessionCart = (): UseIdsSessionType => {
    const checkForSessionCart = () => {
        if (typeof window === 'undefined') {
            return { ociSessionId: undefined };
        }

        const isOciSessionString = localStorage.getItem(LOCAL_STORAGE_KEY);

        if (isOciSessionString) {
            return {
                ociSessionId: isOciSessionString
            };
        }

        return { ociSessionId: undefined };
    };

    return { checkForSessionCart };
};
